import { IGetCaptableResponse } from 'dashboard409a/services/types';

export interface DistributionRow {
  id: number;
  name: string;
  value: number;
}

// Scales each security's liquidation preference proportionally so the
// distributions sum to the entered exit equity value; with no exit value the
// raw preferences are shown as-is.
export const buildDistributionRows = (
  exitEquityValue: string,
  data: IGetCaptableResponse | null
): DistributionRow[] => {
  if (!data) {
    return [];
  }

  const { securities } = data;
  const exitValue = Number.parseFloat(exitEquityValue);
  const total = securities.reduce((prev, current) => prev + Number.parseFloat(current.total_preference), 0);

  return securities.map(security => {
    const preference = Number(security.total_preference);
    const adjusted = total > 0 ? ((exitValue - total) / total) * preference + preference : preference;
    return {
      id: security.id,
      name: security.name,
      value: exitValue > 0 ? adjusted : preference,
    };
  });
};
